export { default } from '../../src/pages/Event'
